const reject = () => {
  return (
    <svg height="24" viewBox="0 -960 960 960" width="24" fill={"white"}>
      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>
  );
};

export default reject;
